export const getDomainHint = () =>
  new URLSearchParams(window.location.search)?.get('idp') || '';

export const getLoginHint = () =>
  new URLSearchParams(window.location.search)?.get('hint') || undefined;
